<template>
  <div>
    <div class="mb-4">
      <aha-breadcrumb>
        <aha-breadcrumb-item :text="category" />
        <aha-breadcrumb-item
          :text="text"
          :clickable="clickable"
          @click="$emit('click')"
        />
        <aha-breadcrumb-item
          :text="subText"
          v-if="subText.length"
        />
      </aha-breadcrumb>
      <div class="mt-2 text-lg font-bold">
        <h2 class="truncate">
          {{ title ? title : text }}
        </h2>
      </div>
    </div>
    <div class="mb-4 border-b border-secondary-20" v-if="!noBorder" />
  </div>
</template>

<script>
export default {
  props: {
    category: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    subText: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
